'use client';

import { createContext } from 'react';

import type { AddToolOutputFn } from '@/features/copilot/tooling/types';
import type { ToolPartRenderer } from '@/features/copilot/model';

export type CopilotToolUiContextValue = {
  toolPartRenderers: Readonly<Record<string, ToolPartRenderer>>;
  addToolOutput: AddToolOutputFn;
  onSendMessage?: (message: string) => void;
};

export const CopilotToolUiContext = createContext<CopilotToolUiContextValue | null>(null);
